import { useEffect } from 'react';
import { redirectToUpsell } from '$src/utils/redirect';
import isLocationActive from './isLocationActive';

/**
 * This function handles simple redirections for the cases of no locations with entitlements or one active location.
 * 1- If no location exists with entitlements it will redirect to upsell Page
 * 2- If only one location exists and it's active it will redirect to it.
 * @param {*} param0
 */
function useRedirectOnSingleOrNoLocation({ locations, unboardedLocations, onboardedLocations, handleClick, isMobile }) {
  useEffect(() => {

    if(locations !== null ){
      const locationExistsWithEntitlement = locations.some(location => location.hasEntitlements);
      if (!locationExistsWithEntitlement) {
        redirectToUpsell();
      }
    }
    if (locations?.length === 1) {
      if (unboardedLocations.length && isLocationActive(unboardedLocations[0])) {
        handleClick(unboardedLocations[0]);
      } else if (onboardedLocations.length && isLocationActive(onboardedLocations[0])) {
        handleClick(onboardedLocations[0]);
      }
    }
  }, [unboardedLocations, onboardedLocations, handleClick, locations?.length]);
}

export default useRedirectOnSingleOrNoLocation;
